export const setGroup = group => ({
  type: 'SET_GROUP',
  group
});
